import React, {useState} from 'react';
import {NavLink} from 'react-router-dom';
import {Button} from '~/components/Button';
import style from './index.module.scss';

export interface ILinksListProps {
  values: string[];
  maxItems?: number;
  buildTo: (value: string) => string;
}

export const LinksList = ({values, maxItems, buildTo}: ILinksListProps) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  if (!Array.isArray(values) || values.length === 0) return null;

  return (
    <span className={style.tagsList}>
      {values.map((value, index) => (
        <NavLink
          to={buildTo(value)}
          key={`value-${index}`}
          className={
            style.tagsValue +
            ((maxItems && index >= maxItems) ||
            (maxItems && index === maxItems - 1 && values.length !== maxItems)
              ? (expanded ? '' : ' ' + style.hidden)
              : '')
          }
        >
          {value}
        </NavLink>
      ))}
      {Array.isArray(values) && maxItems && values.length > maxItems && !expanded ? (
        <Button
          small
          responsive
          className={style.buttonDashedLink}
          onClick={() => setExpanded(true)}
        >
          + {(values.length - maxItems < 2 ? 2 : values.length - maxItems + 1)} more
        </Button>
      ) : ''}
    </span>
  );
};
